import { Component } from '@angular/core';

@Component({
  selector: 'app-no-app',
  standalone: true,
  templateUrl: './no-app.component.html',
  styleUrl: './no-app.component.scss',
})
export class NoAppComponent {}
